const productCategory = [
    { id: 1, label: "Airpod", value: "airpod" },
    { id: 2, label: "Camera", value: "camera" },
    { id: 3, label: "Earphone", value: "earphone" },
    { id: 4, label: "Mobile", value: "mobile" },
    { id: 5, label: "Mouse", value: "mouse" },
    { id: 6, label: "Printer", value: "printer" },
    { id: 7, label: "Processor", value: "processor" },
    { id: 8, label: "Refrigerator", value: "refrigerator" },
    { id: 9, label: "Speaker", value: "speaker" },
    { id: 10, label: "Trimmer", value: "trimmer" },
    { id: 11, label: "Television", value: "television" },
    { id: 12, label: "Watche", value: "watch" },
]

export default productCategory